import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";
// import { useCase } from "@/features/case/use-case";

export const useCreditorVotesDefs = (caseDetails: any) => {
  const { t } = useTranslation();
  // const caseData = useCase();

  const CustomHeader = () => {
    const { defaultUnit } = caseDetails;
    return `${defaultUnit?.name}`;
  };

  const amountCellRenderer = (field: string) => (params: any) => {
    const { defaultUnit } = caseDetails;
    const decimalPlace = defaultUnit?.decimalPlace;
    const amount = params.data[field];
    // if(["unresolvedCreditorAmount", "unresolvedDebtorAmount"].includes(field) && params.data?.isResolved ) {
    //   return "-";
    // }
    // else if (field === "resolvedAmount" && !params.data?.isResolved) {
    //   return "-";

    // }
    // else{
    return amount === null
      ? "-"
      : `${formatAmountUnitDecimalPlace(amount, decimalPlace)} ${
          defaultUnit?.name
        }`;
    // }
  };

  return [
    {
      field: "voterId",
      type: "voterIdType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column9"),
      minWidth: "130",
      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
      cellRenderer: "voterIdRenderer",
    },
    {
      field: "voterName",
      type: "voterNameType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column10"),
      minWidth: "130",
      wrapText: true,
      autoHeight: true,
      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
    },
    {
      field: "isEligible",
      type: "isEligibleType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column5"),
      minWidth: "130",
      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
      cellRenderer: function (param: any) {
        let { isEligible } = param.data;
        return isEligible === 1 ? "Yes" : isEligible === 0 ? "No" : "-";
      },
    },
    {
      field: "creditorId",
      type: "creditorIdType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column2"),
      minWidth: "130",

      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
    },
    {
      field: "creditorName",
      type: "creditorNameType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column1"),
      minWidth: "150",
      autoHeight: true,
      wrapText: true,
      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
      cellRenderer: (param: any) => {
        return (
          <>
            {
              // <Link
              //   to={`/case/${caseData.caseId}/creditor/${param.data.creditorId}` }
              // >
              //  <span className="text-bold-underline"> {param.data.creditorName} </span>
              // </Link>
              <span> {param.data.creditorName} </span>
            }
          </>
        );
      },
    },
    {
      field: "voteResult",
      type: "voteResultType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column4"),
      minWidth: "130",
      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
      cellRenderer: function (param: any) {
        const { voteResult } = param.data;
        switch (voteResult) {
          case 0:
            return "Yes";
          case 1:
            return "No";
          case 2:
            return "Did Not Vote";
        }
      },
    },
    {
      field: "proxyName",
      type: "proxyNameType",
      headerName: t("pages.voting.creditorVotes.columnDetails.column3"),
      minWidth: "130",

      sortable: true,
      unSortIcon: true,
      cellStyle: { justifyContent: "start" },
    },
    {
      field: "unresolvedCreditorAmount",
      type: "unresolvedCreditorAmountType",
      cellStyle: { justifyContent: "end" },
      cellRenderer: amountCellRenderer("unresolvedCreditorAmount"),
      headerName: t("pages.voting.creditorVotes.columnDetails.column6", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Latest Creditor Position Amount" },
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      minWidth: "200",
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "unresolvedDebtorAmount",
      type: "unresolvedDebtorAmountType",
      cellStyle: { justifyContent: "end" },
      cellRenderer: amountCellRenderer("unresolvedDebtorAmount"),
      headerName: t("pages.voting.creditorVotes.columnDetails.column7", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Latest Debtor Position Amount" },
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      minWidth: "200",
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "resolvedAmount",
      type: "resolvedAmountType",
      cellStyle: { justifyContent: "end" },
      minWidth: "200",
      cellRenderer: amountCellRenderer("resolvedAmount"),
      headerName: t("pages.voting.creditorVotes.columnDetails.column8", {
        unitName: CustomHeader(),
      }),
      headerComponentParams: { params: "Resolved Amount" },
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "action",
      cellRenderer: "actionRenderer",
      headerName: "",
      headerClass: "",
      flex: 1,
      minWidth: "50",
      cellStyle: { justifyContent: "center" },
      sortable: false,
      unSortIcon: false,
    },
  ];
};
